module.exports = __webpack_public_path__ + "img/776A5C_BA9A89_302C26_443C34-256px.94dd75c0.png";